import { Dispatch, SetStateAction } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import {
  CalendarRoles,
  isAbleToSeeUIElement,
} from '../../../../utils/roles/client-roles';
import SharedGridStateIconButton from '../../../../shared/shared-grid-state-icon-button-latest';
import { ModuleList } from '../../../../shared/analytics/module-list';
import SharedToolbar from '../../../../shared/shared-toolbar-latest';
import CreateButton from '../../../../shared/buttons/create-button';
import SharedIconButton from '../../../../shared/buttons/shared-icon-button';
interface BuildingsGridToolbarProps {
  calendarRoles: string[];
  setOpenCreateBuilding: Dispatch<SetStateAction<boolean>>;
}

export default function BuildingsGridToolbar({
  calendarRoles,
  setOpenCreateBuilding,
}: BuildingsGridToolbarProps) {
  const queryClient = useQueryClient();

  return (
    <SharedToolbar
      primaryButtons={
        <CreateButton
          onClick={() => setOpenCreateBuilding(true)}
          disabled={
            !isAbleToSeeUIElement(
              calendarRoles,
              CalendarRoles.CreateBuildings.value
            )
          }
          label="Add Building"
        />
      }
      secondaryButtons={
        <>
          <SharedIconButton
            variant="refresh"
            onClick={() => {
              void queryClient.invalidateQueries({
                queryKey: ['BuildingsList'],
              });
            }}
            tooltipLabel="Refresh"
          />
          <SharedGridStateIconButton
            gridStateKey="buildingsGridStates"
            module={ModuleList.modules.calendars.name}
            section={ModuleList.modules.calendars.sections.buildings}
          />
        </>
      }
    />
  );
}
